export default function normalizeAnnotationDate(_story, date: Date): Date {
  const normalizedDate = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0)
  );

  return normalizedDate;
}
